import React, { Component } from "react";
import DiscountPanel from "../../components/DiscountPanel";
import { Error, CheckCircle } from "@styled-icons/material";
import Details from "../../components/Details";
import { TextQuestionWithButton } from "../../components/TextQuestion";

// Wording for the referrer flow. The agent is entering their own agency's code to get
// their agreed pricing, not a code they were given by an agent or a friend.
export const referrerCodeCopy = {
  summary: "Have a referral code?",
  label: "Referral code",
  hint: "If your agency has been given a referral code, enter that here.",
};

class ReferralCodeControl extends Component {
  constructor(props) {
    super(props);
    this.state = {
      referralCode: this.props.referral ? this.props.referral.referralCode : "",
      referralCodeError: null,
      referral: this.props.referral,
      referralCodeValid: !!this.props.referral,
    };
  }

  applyReferralCode = () => {
    this.setState({
      applyEnabled: false,
      referralCodeError: null,
      referral: null,
      referralCodeValid: false,
    });

    const referralCode = this.state.referralCode;
    let url = `/api/referralCode/${referralCode}`;
    if (!!this.props.audience) {
      url += `?audience=${this.props.audience}`;
    }

    fetch(url)
      .then((resp) => resp.json())
      .then(
        (referralData) => {
          if (this.state.referralCode !== referralCode) return;

          const referral = {
            referralCode: this.state.referralCode,
            discountAmount: referralData.discountAmount,
            discountMessage: referralData.discountMessage,
            quoteMessage: referralData.quoteMessage,
            referralSource: referralData.referralSource,
          };

          this.setState({
            referralCodeError: referralData.referralCodeError,
            referral: referral,
            referralCodeValid: referralData.referralCodeValid,
          });
          this.props.onReferralCodeApplied(referralData.referralCodeValid ? referral : null);
        },
        () => {
          this.setState({
            referralCodeError: "unable to retrieve referral code",
            referral: null,
            referralCodeValid: false,
          });
        },
      );
  };

  referralCodeEntered = (code) => {
    this.setState({
      referralCode: code,
      applyEnabled: true,
    });
  };

  render() {
    let discountStatus;
    if (this.state.referralCodeError) {
      discountStatus = (
        <DiscountPanel invalid>
          <Error size={24} />
          {this.state.referralCodeError}
        </DiscountPanel>
      );
    } else if (this.state.referral) {
      discountStatus = (
        <DiscountPanel valid data-testid="discount-panel-valid">
          <CheckCircle size={24} />
          {this.state.referral.discountMessage || "Referral code applied successfully"}
        </DiscountPanel>
      );
    }

    // The direct flow shows this to a client, who may have a code from their agent or a
    // friend. The referrer flow shows it to the agent themselves, who only ever enters
    // their own agency's referral code, so both flows need their own wording.
    const summary = this.props.summary || "Have a code from your estate agent or a friend?";
    const label = this.props.label || "Referral code";

    return (
      <Details summary={summary}>
        {discountStatus}
        <TextQuestionWithButton
          question={label}
          hint={this.props.hint}
          value={this.state.referralCode}
          valueEntered={this.referralCodeEntered}
          buttonText="Apply code"
          buttonAction={this.applyReferralCode}
        />
      </Details>
    );
  }
}

export default ReferralCodeControl;
